export default {
  meta: {
    title: '集客点审批详情',
  }
};
